<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication"><br/><br/><br/><br/><br/>
<h1>Dedication</h1><br/><br/>
<p style="text-align: center;">I dedicate this novel to my friends:</p>
<p style="text-align: center;">Mohamed Cherouk</p>
<p style="text-align: center;">Mohand Benamara</p><br/>
<p style="text-align: center;">And my grandchildren:</p>
<p style="text-align: center;">Hocine Azzedine Ferhat</p>
<p style="text-align: center;">Islam Ferhat</p>
<p style="text-align: center;">Tarek Kechroud</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?597bbea7